import { useEffect } from "react";
import Footer from "../components/Footer";
import PublicNav from "../components/PublicNav";

const SECTIONS = [
  {
    title: "1. About Joborigo",
    content: `Joborigo is a recruitment transparency and application tracking platform operated by Stefan Asanin, trading as Joborigo (enskild firma), registered in Sweden. By using Joborigo you agree to these Terms of Service.

Contact: support@joborigo.com`,
  },
  {
    title: "2. Eligibility",
    content: `You must be at least 16 years old to use Joborigo. By registering, you confirm that the information you provide is accurate and that you will keep it up to date.`,
  },
  {
    title: "3. Your account",
    content: `You are responsible for maintaining the security of your account credentials. You must not share your account with others or use another person's account.

We reserve the right to suspend or terminate accounts that violate these Terms, engage in abusive behaviour, or are used fraudulently.`,
  },
  {
    title: "4. Free and paid services",
    content: `Joborigo is free for job seekers. There is no trial period, no paywall and no usage limit on job seeker accounts. Agencies and employers pay for their side of the platform, and those subscriptions fund the service.

Agency and employer plans: billed monthly or annually via Paddle, with the features described on our pricing page. You may cancel at any time. Cancellation takes effect at the end of the current billing period.

Right of withdrawal (consumers): If you are a consumer in the EU, you have the right to withdraw from a paid subscription within 14 days of purchase, without giving any reason, in accordance with the Swedish Distance and Off-Premises Contracts Act (lag 2005:59). However, if you expressly request that the service begins immediately and acknowledge that you thereby waive your right of withdrawal, the 14-day right will not apply once the service has commenced. To exercise your right of withdrawal, contact us at support@joborigo.com.

The 14-day right of withdrawal does not apply to business customers.

Refunds: Outside of the right of withdrawal described above, no refunds are issued for partial billing periods, except where required by mandatory consumer protection law. This limitation does not affect your statutory rights as a consumer.

Prices are shown inclusive of applicable VAT. Paddle acts as Merchant of Record. See Section 4a for details.`,
  },
  {
    title: "4a. Payments and Merchant of Record",
    content: `All payments for Joborigo subscriptions are processed by Paddle.com Market Limited ("Paddle"), which acts as the Merchant of Record for all transactions. This means that when you purchase a subscription, your payment contract is with Paddle, and Paddle is the seller of record for billing, VAT, and payment-related matters.

Paddle's own terms of service and privacy policy apply to the payment transaction. Joborigo remains responsible for the delivery of the service itself.

For billing disputes, chargebacks, or payment errors, please contact Paddle directly via paddle.com/support. For service-related issues, contact us at support@joborigo.com.`,
  },
  {
    title: "4b. Entering into a subscription agreement",
    content: `When you purchase an agency or employer plan, the following steps apply:

1. You select a subscription plan on our pricing page.
2. You are redirected to Paddle's checkout to enter your payment details.
3. You review and confirm your order by clicking the "Subscribe" or equivalent button.
4. Your subscription agreement is concluded at the moment Paddle confirms your payment.
5. You will receive an order confirmation by email.

These Terms of Service, together with your order confirmation, constitute the full agreement between us. We do not separately archive individual subscription contracts, but you can always access the current Terms of Service at joborigo.com/terms.`,
  },
  {
    title: "5. Employer and agency API",
    content: `Employers and agencies who access the Joborigo API agree to the following:

• API keys must not be shared publicly or embedded in client-side code.
• The API may only be used to push genuine, accurate status updates to candidates who have a Joborigo account and have interacted with your job position.
• You must not use the API to send unsolicited messages, spam, or misleading information.
• We reserve the right to revoke API access for violations of these terms.

You remain responsible for the accuracy of status updates sent to candidates via the API.`,
  },
  {
    title: "6. Candidate arena",
    content: `Job seekers who opt into the candidate arena:
• Consent to their anonymised profile being visible to registered employers.
• Understand that their name, gender, age, nationality, and photo are never shown.
• May opt out at any time from Account Settings.

Employers browsing the arena:
• May not attempt to de-anonymise candidate profiles.
• May only contact candidates by sending a job position through the Joborigo platform.`,
  },
  {
    title: "7. Acceptable use",
    content: `You agree not to:
• Use Joborigo for any unlawful purpose
• Attempt to reverse engineer, scrape, or extract data from the platform
• Interfere with or disrupt the security or integrity of the service
• Impersonate another person or organisation
• Upload malicious code or content

We reserve the right to remove any content that violates these terms.`,
  },
  {
    title: "8. Data and privacy",
    content: `Your use of Joborigo is also governed by our Privacy Policy, which is incorporated into these Terms by reference and available at joborigo.com/privacy.

We process your personal data on the legal bases set out in GDPR Article 6, primarily contract performance (to provide the service), legitimate interests (security and improvements), and legal obligation. Where any processing requires your explicit consent (e.g. marketing communications), we will ask for it separately, and you may withdraw that consent at any time without affecting the lawfulness of prior processing.

We do not rely on broad blanket consent as a legal basis. Please read the Privacy Policy for full details on how we collect, use, and protect your personal data, and how you can exercise your rights under the GDPR.`,
  },
  {
    title: "9. Intellectual property",
    content: `All content, design, code, and branding on Joborigo is owned by or licensed to Stefan Asanin / Joborigo. You may not reproduce, distribute, or create derivative works without written permission.

You retain ownership of the data you enter into Joborigo (your applications, notes, timeline entries, etc.). You grant us a limited licence to store and process this data to provide the service.`,
  },
  {
    title: "10. Disclaimers and limitation of liability",
    content: `Joborigo is provided "as is" and we do not guarantee that the service will be uninterrupted, error-free, or that data will never be lost. We will, however, make reasonable efforts to maintain the availability and integrity of the service.

Limitation of liability (business customers): To the maximum extent permitted by law, Joborigo's total liability for any claim arising out of your use of the service is limited to the amount you paid us in the 12 months preceding the claim. We are not liable for indirect, incidental, or consequential losses.

Consumer rights: If you are a consumer, the above limitation of liability does not apply to the extent that it would exclude or restrict your rights under mandatory Swedish or EU consumer protection legislation. In particular, nothing in these Terms excludes or limits our liability for:
• Death or personal injury caused by our negligence;
• Fraud or fraudulent misrepresentation;
• Any other liability that cannot be excluded or limited under applicable law.

Your statutory rights as a consumer are not affected by these Terms.`,
  },
  {
    title: "11. Governing law and jurisdiction",
    content: `These Terms are governed by Swedish law.

Business customers: Any disputes will be subject to the exclusive jurisdiction of Swedish courts.

Consumers: If you are a consumer resident in the European Union, you also benefit from any mandatory provisions of the law of the country in which you are resident, and nothing in these Terms affects your rights to rely on such mandatory local consumer protection. Disputes may also be resolved through the EU Online Dispute Resolution platform at ec.europa.eu/consumers/odr, or through the Swedish National Board for Consumer Disputes (Allmänna reklamationsnämnden, ARN) at arn.se.`,
  },
  {
    title: "12. Changes to these Terms",
    content: `We may update these Terms from time to time. Material changes will be communicated by email to your registered address at least 14 days before taking effect.

If you have an active paid subscription, material changes will not take effect until the start of your next billing period following the 14-day notice period, unless the change is required by law.

If you do not accept the revised Terms, you may cancel your subscription before the changes take effect. Continued use of Joborigo after the changes take effect constitutes acceptance of the new Terms.`,
  },
  {
    title: "13. Contact",
    content: `For questions about these Terms, contact us at support@joborigo.com.

For payment-related enquiries, please contact Paddle directly via paddle.com/support.`,
  },
];

export default function Terms() {
  useEffect(() => {
    document.title = "Joborigo: Terms of Service";
  }, []);

  return (
    <div className="min-h-screen flex flex-col bg-white dark:bg-brand-dark-bg text-gray-900 dark:text-gray-100">
      <PublicNav />

      <main className="flex-1 max-w-3xl mx-auto px-6 py-16 w-full">
        <div className="mb-12">
          <p className="text-sm font-medium text-brand-violet dark:text-brand-violet-on-dark mb-3 uppercase tracking-widest">
            Legal
          </p>
          <h1 className="text-4xl font-extrabold mb-4">Terms of Service</h1>
          <p className="text-gray-400 text-sm">
            Last updated: September 2026 · Effective immediately
          </p>
          <p className="text-gray-500 dark:text-gray-400 mt-4 leading-relaxed">
            Please read these Terms carefully before using Joborigo. By creating
            an account or using the service, you agree to be bound by these
            Terms.
          </p>
        </div>

        <div className="flex flex-col gap-10">
          {SECTIONS.map((section) => (
            <section key={section.title}>
              <h2 className="text-lg font-bold text-gray-900 dark:text-white mb-3">
                {section.title}
              </h2>
              <div className="text-gray-500 dark:text-gray-400 leading-relaxed whitespace-pre-line text-sm">
                {section.content}
              </div>
            </section>
          ))}
        </div>

        <div className="mt-16 pt-8 border-t border-gray-100 dark:border-white/10">
          <p className="text-sm text-gray-400">
            Questions about these Terms? Contact us at{" "}
            <a
              href="mailto:support@joborigo.com"
              className="text-brand-violet dark:text-brand-violet-on-dark hover:underline"
            >
              support@joborigo.com
            </a>
          </p>
        </div>
      </main>

      <Footer />
    </div>
  );
}
